import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import _, { isEmpty } from "lodash";
import { entitySelector, fetchEntities, destroyEntity } from "../../../../shared/entity/slice";
import {
    parseTableQueryParams,
    buildTableQueryParams,
} from "../../../../../utils/tableQueryParams";
import AbstractTable from "./view";

import useTableParams from "../../../../../hooks/useTableParams";


export const filterNestedEntity = (field, entityDefaultObject) =>
    entityDefaultObject ? !Object.keys(entityDefaultObject).includes(field.name) : field;

const AbstractTableContainer = ({ options, entityDefaultObject, isFromClient }) => {

    const initialParams = {
        pageIndex: 0,
        pageSize: 10,
        sortField: options.entityName === "projects" ? "updatedAt" : "createdAt",
        sortDirection: "desc",
        searchQuery: "",
    };
    const [{ pageIndex, pageSize, sortField, sortDirection, searchQuery }, setParams] =
        useTableParams(initialParams);
    const dispatch = useDispatch();
    const { data, included, isLoading, hasErrors, meta } = useSelector(
        entitySelector(options.entityName)
    );
    const totalRecordCount = meta?.totalRecordCount;
    const history = useHistory();
    const location = useLocation();

    const isNested = !!options.url;

    const formIncludedFields = options.formFields.filter((field) =>
        isNested ? filterNestedEntity(field, entityDefaultObject) && field.include : field.include
    );
    const previewIncludedFields = options.previewFields.filter((field) =>
        isNested ? filterNestedEntity(field, entityDefaultObject) && field.include : field.include
    );
    const includedFields = _.uniqBy(
        [...formIncludedFields, ...previewIncludedFields],
        (e) => e.entityName
    );

    const includedEntitiesString = includedFields.length
        ? includedFields.map((field) => field.entityName).join(",")
        : null;

    const [filterOptions, setFilterOptions] = useState([]);
    const [filterQuery, setFilterQuery] = useState(null);
    //  * locations filters queries

    function extractQueryValue(filters) {
        const finalResult = {};
        for (const filter in filters) {
            const queryValue = [];
            const values = filters[filter]?.value || [];
            for (const value of values) {
                queryValue.push(value?.value);
            }
            if (queryValue.length > 0) {
                finalResult[filter] = queryValue;
            }
        }
        return finalResult;
    }
    const handleLocationQuery = () => {
        const mapedQuery = extractQueryValue(filterOptions[0]);
        setFilterQuery(mapedQuery);
    };

    useEffect(() => {
        let filters = filterOptions.map((option) => option.value);
        if (options.entityName === "organizationAssignees") {
            setFilterQuery(null);
            if (filters.length === 0 || filters.length === 2) {
                setFilterQuery(null);
            } else if (filters.includes("Managerial")) {
                setFilterQuery({ assigneeType: ["managerial"] });
            } else {
                setFilterQuery({ assigneeType: ["on_ground"] });
            }
        }
        if (
            options.entityName === "locations" ||
            options.entityName === "suppliers" ||
            options.entityName === "trucks" ||
            options.entityName === "drivers" ||
            options.entityName === "projects"
        ) {
            if (filterOptions.length === 0) {
                setFilterQuery(null);
            } else {
                handleLocationQuery();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterOptions]);

    useEffect(() => {
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterQuery]);

    useEffect(() => {
        fetch();
        if (!entityDefaultObject) {
            const queryParams = buildTableQueryParams(
                pageIndex,
                pageSize,
                sortField,
                sortDirection,
                searchQuery,
                options.displayName || options.entityName,
                "database" // Menu
            );
            history.push(queryParams);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageIndex, pageSize, sortField, sortDirection, searchQuery, options]);

    useEffect(() => {
        if (!_.isEmpty(location.search)) {
            const parsedParams = parseTableQueryParams(location.search);
            setParams(parsedParams);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetch = () => {
        dispatch(
            fetchEntities(
                options.entityName,
                pageIndex,
                pageSize,
                sortField,
                sortDirection,
                searchQuery,
                includedEntitiesString,
                null,
                (options.entityName === "projects" ||
                    options.entityName === "organizationAssignees" ||
                    options.entityName === "locations" ||
                    options.entityName === "suppliers" ||
                    options.entityName === "trucks" ||
                    options.entityName === "drivers") &&
                    filterQuery
                    ? filterQuery
                    : null,
                null,
                options.url
            )
        );
    };

    const onChange = ({ page = {}, sort = {} }) => {
        const { index: pageIndex, size: pageSize } = page;
        const { field: sortField, direction: sortDirection } = sort;
        setParams({ pageIndex, pageSize, sortField, sortDirection });
    };

    const onSearchQueryChange = (queryText) => {
        setParams({ searchQuery: queryText });
    };

    const sorting = {
        sort: {
            field: sortField,
            direction: sortDirection,
            enableAllColumns: true,
        },
    };

    const pagination = {
        pageIndex,
        pageSize,
        totalItemCount: totalRecordCount,
        pageSizeOptions: [10, 20, 30, 50],
    };
    return (
        <AbstractTable
            data={data}
            includedData={included}
            includedFields={includedFields}
            isLoading={isLoading}
            hasErrors={hasErrors}
            onChange={onChange}
            pagination={pagination}
            sorting={sorting}
            searchQuery={searchQuery}
            onSearchQueryChange={onSearchQueryChange}
            reFetch={fetch}
            options={options}
            dispatch={dispatch}
            destroyEntity={destroyEntity}
            entityDefaultObject={entityDefaultObject}
            projectOptions={filterOptions}
            setProjectOptions={setFilterOptions}
            isFromClient={isFromClient}
        />
    );
};

export default AbstractTableContainer;
